import { getRoomNameAndSynonym } from '../../../../../../helpers/dspx-utils';

const porchTypeId = 2;

export const generateRoomTitle = (item) => {
  const type = item.typeId !== porchTypeId ? item.typeShortName?.trim() : '';
  const [name, synonym] = getRoomNameAndSynonym(
    item.name?.trim() || item.flat?.trim()
  );
  return [name, type, synonym].filter(Boolean).join(' ');
};
